export enum ButtonType {
  STROKED = 'STROKED',
  FLAT = 'FLAT',
  SUBMIT = 'SUBMIT',
}
